export default {"src":"/_next/static/media/report-icon-blue.da6774d5.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};